// Replace direct database calls with API calls to backend

export default async function updateUser(info: any) {
  try {
    const token = localStorage.getItem('auth_token');
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/users/profile`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(info)
    });
    
    if (!response.ok) {
      throw new Error('Failed to update user');
    }
    return await response.json();
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
}
